// extracted by mini-css-extract-plugin
export default {"backButton":"styles_backButton__rvGcI"};